export default __webpack_public_path__ + "static/media/manageMyPrograms.8253e69a.svg";